import React, { useEffect, useCallback, useState } from "react";
import  {
  FlyToInterpolator,
  StaticMap,
} from "react-map-gl";
import DeckGL from "@deck.gl/react";
import { easeBackInOut } from "d3";

import { createAirbaseLayers } from "./layers/airbaseLayers";
import { createAirbaseLayersMob } from "./layers/airbaseLayersMob";
import { createImageLayer } from "./layers/bitmapLayers";
import { createImageLayerMob } from "./layers/bitmapLayersMob";


import { MapView} from "@deck.gl/core";


const VIEWS = [
  new MapView({
    id: "base-map",
    width: "100%",
    //clear: true,
    controller: true,
  }),
];

export default function Map(props) {
  const currentSlide = props.currentSlide;
  if (!currentSlide.map) {
    return null;
  }
  const LAYERS_DATA = props.layers;

  const airbaseLayer = createAirbaseLayers(currentSlide);  
  const airbaseLayerMob = createAirbaseLayersMob(currentSlide);
  const imageLayer = createImageLayer (currentSlide);
  const imageLayerMob = createImageLayerMob (currentSlide);


  const LAYERS = [].concat(
    airbaseLayer, 
    imageLayer, 
  );

  const LAYERSMob = [].concat(
    airbaseLayerMob, 
    imageLayerMob, 
  );

  //console.log (airbaseLayer)

  return (
  props.isMobile? (
    <div
    id={"map-layers"}
    style={{
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      backgroundColor: "black", // "black", 7dffb3  00ff7f
      pointerEvents: "none",
      zindex: "100",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      // padding: "0vw 10vw",
    }}
  >
    <DeckGL
      initialViewState={props.viewState}
      controller={true}
      views={VIEWS}
      layers= {LAYERSMob}      
      >
      <MapView >
        <StaticMap
          mapboxApiAccessToken={props.MAPBOX_TOKEN}
          mapStyle={props.mapStyle}
        />
      </MapView>
    </DeckGL>
  </div>
  ):
  (
    <div
    id={"map-layers"}
    style={{
      position: "fixed",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      backgroundColor: "black", // "black", 7dffb3  00ff7f
      pointerEvents: "none",
      zindex: "100",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      // padding: "0vw 10vw",
    }}
  >
    <DeckGL
      initialViewState={props.viewState}
      controller={true}
      views={VIEWS}
      layers= {LAYERS}      
      >
      <MapView >
        <StaticMap
          mapboxApiAccessToken={props.MAPBOX_TOKEN}
          mapStyle={props.mapStyle}
        />
      </MapView>
    </DeckGL>
  </div>
  )
  );
}





